import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
    selector: 'td[lcs-cell]',
    standalone: false
})
export class AutoTitleDirective implements AfterViewInit, OnDestroy {
   private observer!: ResizeObserver;

   constructor(private el: ElementRef, private renderer: Renderer2) {}

   ngAfterViewInit(): void {
      const element = this.el.nativeElement;

      this.observer = new ResizeObserver(() => {
         this.applyTitle();
      });

      this.observer.observe(element);

      requestAnimationFrame(() => this.applyTitle());
   }

   ngOnDestroy(): void {
      this.observer?.disconnect();
   }

   private applyTitle() {
      const element = this.el.nativeElement;

      const content = element.querySelector('.table-button, .cell-content, a') || element;

      const clone = content.cloneNode(true) as HTMLElement;

      clone.querySelectorAll('mat-icon').forEach((icon) => icon.remove());

      let text = clone.textContent?.trim();

      if (!text) {
         const icon = content.querySelector('mat-icon');
         const iconName = icon?.getAttribute('ng-reflect-font-icon') || icon?.textContent?.trim();

         if (iconName === 'check') {
            text = 'Yes';
         }
      }

      const isOverflowing = content.scrollWidth > content.clientWidth;

      if (text && isOverflowing) {
         this.renderer.setAttribute(element, 'title', text);
      } else {
         this.renderer.removeAttribute(element, 'title');
      }
   }
}
